import { render } from "./documentEmail.vue?vue&type=template&id=38983ee1"
import script from "./documentEmail.vue?vue&type=script&lang=js"
export * from "./documentEmail.vue?vue&type=script&lang=js"

import "./documentEmail.vue?vue&type=style&index=0&id=38983ee1&lang=scss"

import exportComponent from "D:\\a\\1\\s\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/documentEmail.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "38983ee1"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('38983ee1', __exports__)) {
    api.reload('38983ee1', __exports__)
  }
  
  module.hot.accept("./documentEmail.vue?vue&type=template&id=38983ee1", () => {
    api.rerender('38983ee1', render)
  })

}


export default __exports__